<template>
  <div class="contacts">
    <TopBar />
    <h2>Contactos</h2>
    <ContactForm />
    <div class="social-links">
      <a href="https://web.facebook.com/KARATEANAM" target="_blank"><img src="https://cdn-icons-png.flaticon.com/512/733/733547.png" alt="Facebook" width="32" /></a>
      <a href="https://www.instagram.com/anamkarate/" target="_blank"><img src="https://cdn-icons-png.flaticon.com/512/733/733558.png" alt="Instagram" width="32" /></a>
    </div>
    <Footer :hideForm="true" />
  </div>
</template>

<script>
import TopBar from '@/components/TopBar.vue';
import Footer from '@/components/Footer.vue';
import ContactForm from '@/components/ContactForm.vue';

export default {
  name: 'Contacts',
  components: { TopBar, Footer, ContactForm },
};
</script>

<style scoped>
.contacts {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.contacts h2,
.contacts .social-links {
  padding: 0 1rem;
}
.social-links {
  margin: 2rem 0;
  display: flex;
  gap: 1rem;
}

@media (max-width: 480px) {
  .contacts h2 {
    font-size: 1.3rem;
  }
}
</style>
